// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__hDeW+","subtitle":"styles_subtitle__RS+xL","go-to-location":"styles_go-to-location__Pe+kz","requirements-title":"styles_requirements-title__GIiR1"};